var _polyline, _line, _line2, _line3, _line4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorRamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "31.717 13.71 31.717 11.889 10.283 20.548 10.283 22.207"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.306,
    y1: 21.781,
    x2: 14.306,
    y2: 30.111
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.938,
    y1: 20.014,
    x2: 18.938,
    y2: 28.344
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.272,
    y1: 17.851,
    x2: 23.272,
    y2: 26.181
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.694,
    y1: 15.849,
    x2: 27.694,
    y2: 24.179
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorRamp);
export default __webpack_public_path__ + "static/media/indoor-ramp.91262c039225bb6457d6f1cb343fb8d9.svg";
export { ForwardRef as ReactComponent };